import React, { Component } from 'react';
import {
    Container,
    Header,
    Grid,
    Menu,
    Button,
    Table,
    Icon,
    Image,
    Pagination,
    Loader,
    Label,
    List
} from 'semantic-ui-react';
import { ajaxPost } from '../ajax';
import { checkDateRange, isTaskAvailable } from '../utils';

// Models
import GSISContributionSummaryReport from './ReportModels/LoanReport/GSISContributionSummaryReport';
import HDMFContributionSummaryReport from './ReportModels/LoanReport/HDMFContributionSummaryReport';
import LoanPaymentSummaryReport from './ReportModels/LoanReport/LoanPaymentSummaryReport';
import LoanSummaryReport from './ReportModels/LoanReport/LoanSummaryReport';
import SSSContributionSummaryReport from './ReportModels/LoanReport/SSSContributionSummaryReport';

// Modals
import LoanFilterModal from './ReportModels/LoanReport/LoanFilterModal';
import LoanPaymentFilterModal from './ReportModels/LoanReport/LoanPaymentFilterModal';

class LoanReportsModule extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            activeReport: 'Loan Summary Report',
            reportModel: null,
            rows: [],
            loading: false,
            isFilterActive: false,
            parameters: null,

            // Pagination
            activePage: 1,
            totalPages: 0,
            totalResultsCount: 0,
            itemsPerPage: 20,

            disAbleExport: true,
        };

        this.filter = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.props.prevState) {
            this.restoreState(this.props.prevState);
        } else {
            this.setReportModel(this.state.activeReport);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.pollingTimer) {
            clearInterval(this.pollingTimer);
        }
        if (this.props.unmountCallback) {
            const stateToSave = { ...this.state };
            delete stateToSave.reportModel;
            this.props.unmountCallback(stateToSave, "LoanReportsModule");
        }
    }

    restoreState = (prevState) => {
        const reportModel = this.createReportModel(prevState.activeReport);
        this.setState({
            ...prevState,
            reportModel
        });
    }

    createReportModel = (reportType) => {
        switch (reportType) {
            case 'GSIS Loan Contribution Summary Report': return new GSISContributionSummaryReport();
            case 'Pag-IBIG Loan Contribution Summary Report': return new HDMFContributionSummaryReport();
            case 'Loan Payment Summary Report': return new LoanPaymentSummaryReport();
            case 'Loan Summary Report': return new LoanSummaryReport();
            case 'SSS Loan Contribution Summary Report': return new SSSContributionSummaryReport();
            default: return null;
        }
    }

    setReportModel = (reportType) => {
        const reportModel = this.createReportModel(reportType);

        if (this._isMounted) {
            this.setState({
                reportModel,
                activeReport: reportType,
                rows: [],
                totalResultsCount: 0,
                totalPages: 0,
                activePage: 1,
                disAbleExport: true,
                isFilterActive: false
            });
        }
    };

    handleReportClick = (report) => {
        this.setReportModel(report);
    };

    showFilters = () => {
        if (this.state.loading) {
            alert("Please wait until the process is done.");
            return;
        }
        this.setState({ isFilterActive: true });
    }

    btnGenerate_Click = () => {
        if (!this.filter.current) return;
        const params = this.filter.current.getParameters();
        this.runSearchWithParams(params);
    }

    runSearchWithParams = (params) => {
        if (!params) {
            alert("Select filter parameter first.");
            return;
        }

        // Validate Date Range if present (used in LoanSummaryReport / LoanFilterModal)
        if (params.startDate !== undefined && params.endDate !== undefined) {
            var checkDateParam = checkDateRange(params.startDate, params.endDate);
            if (!checkDateParam.Result) {
                alert(checkDateParam.Message);
                return;
            }
        }

        this.setState({ parameters: params, isFilterActive: false, activePage: 1 }, () => {
            setTimeout(() => {
                if (this._isMounted) {
                    this.setState({ disAbleExport: false }, this.onSearch);
                }
            }, 500);
        });
    }

    onSearch = () => {
        this.setState({ rows: [], loading: true });
        const { parameters, activePage, itemsPerPage, reportModel, activeReport } = this.state;

        let searchParams = { ...parameters };
        searchParams.pageNumber = activePage;
        searchParams.itemsPerPage = itemsPerPage;
        searchParams.ReportTitle = activeReport;
        searchParams.startingIndex = (activePage - 1) * itemsPerPage;

        console.log('LoanReportsModule - onSearch called');
        console.log('LoanReportsModule - activeReport:', activeReport);
        console.log('LoanReportsModule - searchParams:', searchParams);

        reportModel.search(
            searchParams,
            (data) => {
                console.log('LoanReportsModule - Search response:', data);
                // Loan reports use background processing - data is a processId
                var param = { processId: data };
                this.startPolling(param, "GENERATE");
            },
            (error) => {
                alert("Error:\r\n" + JSON.stringify(error));
                if (this._isMounted) this.setState({ loading: false });
            },
            () => { }
        );
    }

    startPolling = (param, action) => {
        // Clear any existing timer
        if (this.pollingTimer) clearInterval(this.pollingTimer);

        this.pollingTimer = setInterval(() => {
            if (!this._isMounted) {
                clearInterval(this.pollingTimer);
                return;
            }

            ajaxPost({
                data: param,
                url: 'api/BackgroundProcess/GetStatus',
                onSuccess: data => {
                    if (data.Status === "DONE") {
                        clearInterval(this.pollingTimer);

                        setTimeout(() => {
                            if (this._isMounted) {
                                if (action === "GENERATE") {
                                    this.populateRows(JSON.parse(data.ResultParameters));
                                } else if (action === "GENERATE_PDF") {
                                    this.state.reportModel.processSTDPdfData(JSON.parse(data.ResultParameters));
                                    this.setState({ loading: false });
                                } else if (action === "GENERATE_EXCEL") {
                                    this.state.reportModel.exportToExcel(JSON.parse(data.ResultParameters),
                                        data => { },
                                        (err) => { },
                                        () => { }
                                    );
                                    this.setState({ loading: false });
                                }

                                // Clean background process
                                this.cleanBackgroundProcess(param);
                            }
                        }, 100);
                    }
                },
                onError: (error) => {
                    clearInterval(this.pollingTimer);
                    alert("Error status:\r\n" + JSON.stringify(error));
                    if (this._isMounted) this.setState({ loading: false });
                },
                finally: () => { }
            });
        }, 1000); // Check every 1 second
    }

    cleanBackgroundProcess = (param) => {
        setTimeout(() => {
            ajaxPost({
                data: param,
                url: 'api/BackgroundProcess/Delete',
                onSuccess: data => { },
                onError: (err) => { },
                finally: () => { }
            });
        }, 500);
    }

    populateRows = (data) => {
        console.log('LoanReportsModule - Data received:', data);
        console.log('LoanReportsModule - data.Data:', data.Data);
        console.log('LoanReportsModule - data.TotalCount:', data.TotalCount);

        let rows = [];
        if (data.Data) {
            data.Data.forEach(element => {
                rows.push(this.state.reportModel.toTableRow(element));
            });
        }

        // Handle null/undefined TotalCount - default to 0
        const totalCount = data.TotalCount ?? 0;

        let totalPages = 0;
        if (this.state.itemsPerPage > 0 && totalCount > 0) {
            totalPages = Math.ceil(totalCount / this.state.itemsPerPage);
        }

        // Ensure at least 1 page to prevent invalid pagination display
        if (totalPages === 0) {
            totalPages = 1;
        }

        if (this._isMounted) {
            this.setState({
                rows: rows,
                totalResultsCount: totalCount,
                totalPages: totalPages,
                loading: false
            });
        }
    }

    onPageChange = (event, { activePage }) => {
        const page = Math.floor(activePage);
        if (page === this.state.activePage) return;

        this.setState({ activePage: page }, () => {
            if (!this.state.disAbleExport) {
                this.onSearch();
            }
        });
    }

    onExportToExcel = () => {
        const { reportModel, loading, parameters, activeReport } = this.state;
        if (!reportModel) return;

        if (loading) {
            alert("Please wait until the process is done.");
            return;
        }

        this.setState({ loading: true });
        let exportParams = { ...parameters };
        exportParams.pageNumber = 0;
        exportParams.itemsPerPage = 2147483647;
        exportParams.ReportTitle = activeReport;

        // Ensure startingIndex is 0 for export
        exportParams.startingIndex = 0;
        exportParams.itemCount = 2147483647;

        exportParams.sessionId = global.sessionId;

        reportModel.exportToExcelData(
            exportParams,
            (data) => {
                // Excel export uses background processing
                var param = { processId: data };
                this.startPolling(param, "GENERATE_EXCEL");
            },
            (error) => {
                console.error("Export Error:", error);
                const msg = error.message || (typeof error === 'string' ? error : JSON.stringify(error));
                alert("Error:\r\n" + msg);
                if (this._isMounted) this.setState({ loading: false });
            },
            () => { }
        );
    }

    onExportToPdf = () => {
        const { reportModel, loading, parameters, activeReport } = this.state;
        if (!reportModel) return;

        if (loading) {
            alert("Please wait until the process is done.");
            return;
        }

        this.setState({ loading: true });
        let exportParams = { ...parameters };
        exportParams.ReportTitle = activeReport;
        exportParams.itemCount = 2147483647;
        exportParams.itemsPerPage = 2147483647;
        exportParams.pageNumber = 0;
        exportParams.startingIndex = 0;

        reportModel.exportToPdf(
            exportParams,
            (data) => {
                reportModel.processSTDPdfData(data);
                if (this._isMounted) this.setState({ loading: false });
            },
            (error) => {
                alert("Error:\r\n" + JSON.stringify(error));
                if (this._isMounted) this.setState({ loading: false });
            },
            () => { }
        );
    }

    renderFilters = () => {
        const { activeReport, isFilterActive } = this.state;
        if (!isFilterActive) return null;

        const commonProps = {
            ref: this.filter,
            open: true,
            onSave: this.btnGenerate_Click,
            onCancel: () => this.setState({ isFilterActive: false }),
            title: activeReport,
            parameters: this.state.parameters
        };

        // Loan Payment Summary Report uses Month/Year filter
        if (activeReport === 'Loan Payment Summary Report') {
            return <LoanPaymentFilterModal {...commonProps} />;
        } else {
            // All other reports (Loan Summary, GSIS, HDMF, SSS) use Date Range filter
            return <LoanFilterModal {...commonProps} />;
        }
    }

    render() {
        const { activeReport, rows, loading, totalResultsCount, activePage, totalPages, disAbleExport } = this.state;

        const reports = [
            'GSIS Loan Contribution Summary Report',
            'Pag-IBIG Loan Contribution Summary Report',
            'Loan Payment Summary Report',
            'Loan Summary Report',
            'SSS Loan Contribution Summary Report'
        ];

        return (
            <Container fluid>
                <Header as="h2" style={{ marginBottom: '16px' }}>
                    Loan Reports
                </Header>

                <Grid>
                    <Grid.Column width={3}>
                        <List selection verticalAlign='middle'>
                            {reports.map((report) => {
                                const isActive = activeReport === report;
                                const style = {
                                    cursor: 'pointer',
                                    color: isActive ? '#000' : '#888',
                                    fontWeight: isActive ? 600 : 400,
                                    padding: '10px',
                                    backgroundColor: isActive ? '#f0f0f0' : 'transparent',
                                    borderRadius: '4px'
                                };
                                return (
                                    <List.Item key={report} onClick={() => this.handleReportClick(report)} style={style}>
                                        <List.Content>
                                            <List.Header>{report}</List.Header>
                                        </List.Content>
                                    </List.Item>
                                );
                            })}
                        </List>
                    </Grid.Column>

                    <Grid.Column width={13}>
                        <div style={{ padding: 0, marginTop: '1em', display: 'flex', flexDirection: 'column', height: 'calc(100vh - 150px)' }}>
                            <Header as="h3">{activeReport}</Header>

                            <div style={{ zIndex: 1000, position: 'relative', margin: '0.5em 0.1em' }}>
                                <Menu secondary size="mini" stackable>
                                    <Button size="mini" content="Generate" onClick={this.showFilters} />
                                    <Button size="mini" content="Export To Excel" disabled={disAbleExport} onClick={this.onExportToExcel} />
                                    <Button size="mini" content="Export To PDF" disabled={disAbleExport} onClick={this.onExportToPdf} />
                                    <Loader active={loading} inline='left' style={{ margin: '0 0.5em' }}  />
                                    
                                    <Menu.Menu position="right">
                                        <Label>Total Results Count: {totalResultsCount}</Label>
                                        <Pagination
                                            size="mini"
                                            activePage={activePage}
                                            totalPages={totalPages}
                                            onPageChange={this.onPageChange}
                                            firstItem={{ content: <Icon name='angle double left' />, icon: true }}
                                            lastItem={{ content: <Icon name='angle double right' />, icon: true }}
                                            prevItem={{ content: <Icon name='angle left' />, icon: true }}
                                            nextItem={{ content: <Icon name='angle right' />, icon: true }}
                                        />
                                    </Menu.Menu>
                                </Menu>
                            </div>

                            <div style={{ flex: 1, overflow: 'auto', border: '1px solid rgba(34,36,38,.15)', borderRadius: '4px' }}>
                                <Table celled striped compact size='small' style={{ border: 'none' }}>
                                    <Table.Header>
                                        {this.state.reportModel && this.state.reportModel.createColumnHeaders()}
                                    </Table.Header>
                                    <Table.Body>
                                        {rows}
                                    </Table.Body>
                                </Table>
                            </div>
                        </div>
                    </Grid.Column>
                </Grid>
                {this.renderFilters()}
            </Container>
        );
    }
}

LoanReportsModule.getViewID = () => {
    return "LoanReportsModule";
};

LoanReportsModule.getCaption = () => {
    return "Loan Reports";
};

LoanReportsModule.getViewAccessKey = () => {
    return isTaskAvailable("PAYROLL_VIEW") ? true : false
};

LoanReportsModule.getIcon = () => {
    return (<Image style={{ height: "24px", width: "24px" }} src="/Icons/Reports.png" avatar />);
};

LoanReportsModule.getIconSrc = (size) => {
    return '/Icons/Reports.png';
};

export default LoanReportsModule;
